import logo from "../assets/icons/logo.svg"
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import Button from "./button";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div>
      <hr />
      <div className="px-4 md:px-12 my-10">
        <div className="w-full flex justify-center md:justify-start"><img src={logo} alt="" className="h-4"/></div>
        <p className="capitalize text-sm text-secondary mt-2 text-center md:text-start">Bridging the gap, sharing goodness</p>
        <div className="grid grid-cols-1 md:grid-cols-2 mt-3 items-center text-sm gap-4">
          <div className="text-center md:text-start">© {currentYear} Mosquepay Limited.</div>
          <div className="w-full grid justify-center md:justify-end">
            <div className="flex gap-5 text-emerald-500">
              <Link target="__blank" to={"https://www.facebook.com/mosquepay/"}><Facebook className="h-5 hover:animate-bounce cursor-pointer"/> </Link>
              <Link target="__blank" to={"https://www.instagram.com/mosquepay"}><Instagram className="h-5 hover:animate-bounce cursor-pointer"/> </Link>
              <Link target="__blank" to={"https://www.youtube.com/@mosquepay"}>
                <Youtube className="h-5 hover:animate-bounce cursor-pointer"/>
              </Link> 
              <Link target="__blank" to={"https://x.com/Mosquepay1"}>
                <Twitter className="h-5 hover:animate-bounce cursor-pointer"/>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
